import {
	parseAllowLinks,
	parseEmbedTitle,
} from "../../../markdown_parser/markdown";
import "./discord_embed.scss";

export function DiscordEmbedComponent(props: {
	title?: string;
	description?: string;
	color?: string;
}) {
	return (
		<div
			className="flex w-fit max-w-full flex-col gap-2 rounded-[3px] border-l-4 border-sesh-primary bg-base-dark p-3"
			style={{
				borderColor: props.color,
			}}
		>
			{props.title && (
				<div className="w-full font-semibold">
					{parseEmbedTitle(props.title)}
				</div>
			)}
			{props.description && (
				<div className="description w-full break-words text-sm">
					{parseAllowLinks(
						props.description.replaceAll("\n", "  \n")
					)}
				</div>
			)}
		</div>
	);
}
